/**
 * @owner @Appboy/messaging-experience
 */

import { segmentCohortRemoteLookupValidators } from "@schemas/remoteLookup/segmentCohortRemoteLookupSchema";
import type {
  SegmentCohortRemoteLookupId,
  SegmentCohortRemoteLookupItem,
  SegmentCohortRemoteLookupFilters,
} from "@schemas/types";

import type { RemoteLookupProvider } from "./types";

export const segmentCohortProvider: RemoteLookupProvider<
  SegmentCohortRemoteLookupId,
  SegmentCohortRemoteLookupItem,
  SegmentCohortRemoteLookupFilters
> = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: segmentCohortRemoteLookupValidators,
};
